import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "selected-address-wrapper" };
const _hoisted_2 = { class: "lot-number" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "road-name" };
const _hoisted_5 = { key: 1 };
import { storeToRefs } from 'pinia';
import { pStore } from '@/pinia';
import Chip from '@/components/Common/Chip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectedAddressItem',
    setup(__props) {
        const pRequestMap = pStore.piniaRequestMap;
        const { formData, } = storeToRefs(pRequestMap);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 지번 주소 "),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createVNode(Chip, {
                            text: "지번",
                            "brg-chip-color": "blue"
                        })
                    ]),
                    (_unref(formData).selectedAddress)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(formData).selectedAddress.data.getFullAddress('LOT_NUMBER')), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, " - "))
                ]),
                _createCommentVNode(" 도로명 주소 "),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                        _createVNode(Chip, {
                            text: "도로명",
                            "brg-chip-color": "green"
                        })
                    ]),
                    (_unref(formData).selectedAddress)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(formData).selectedAddress.data.getFullAddress('ROAD_NAME')), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, " - "))
                ])
            ]));
        };
    }
});
